import axios from 'axios';

import { Resolve } from './';
import config from './config';

import { IPaymentPlan } from '@/models/paymentPlan';

interface IData<T> {
  results: T[];
  item_count: number;
  page_count: number;
  current: number;
  next: number;
  previous: number;
}

const url = process.env.VUE_APP_SERVER_PATH;

export const getPaymentPlans = (page = 1, pageSize = 100, includeInactive = false) =>
  new Promise((resolve: Resolve<IData<IPaymentPlan>>, reject) => {
    let queryString = `page=${page}&page_size=${pageSize}&ordering=id`;
    if (includeInactive) {
      queryString += '&include_inactive=true';
    }
    axios
      .get(`${url}/v2/payment-plans?${queryString}`, config())
      .then(response => {
        resolve(response);
      })
      .catch(err => {
        reject(err);
      });
  });
